import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons"

export const TrashAlt = (props) => {
  return <FontAwesomeIcon faIcon={faTrashAlt} {...props} />
}
